import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DianService } from '@app/services/dian.service';
import { IResolution } from '../../empresa-form.type';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-resolucion-form',
  templateUrl: './resolucion-form.component.html',
  styleUrls: ['./resolucion-form.component.css']
})
export class ResolucionFormComponent {
  @Input() id: number;
  @Input() set DataResolution(value: any[]) {
    this._dataResolution = value;
    this.onDataResolutionChange();
  }
  get DataResolution(): any[] {
    return this._dataResolution;
  }

  private _dataResolution: any[] = [];
  exists: boolean = false;
  resolutionForm: FormGroup;

  constructor(private fb: FormBuilder, private dianService: DianService) {
    this.resolutionForm = this.fb.group({
      prefix: ['', Validators.required],
      resolution: ['', Validators.required],
      resolution_date: ['', Validators.required],
      technicalKey: [''],
      from: [null, [Validators.required, Validators.min(0)]],
      to: [null, [Validators.required, Validators.min(0)]],
      dateFrom: ['', Validators.required],
      dateTo: ['', Validators.required],
      expiration_date: ['', Validators.required],
      typeDocumentId: [0],
      numberFinish: ['']
    });
  }

  onDataResolutionChange(): void {
    this.resolutionForm.reset();
    if (this.DataResolution) {
      this.resolutionForm.patchValue(this.DataResolution);
      this.exists = true;
    }
  }

  post(): void {
    if (this.resolutionForm.valid) {
      let data: IResolution = this.resolutionForm.getRawValue();
      this.dianService.postResolucion(data).subscribe(
        resp => {
          // Alerta de éxito
          Swal({
            type: 'success',
            title: '¡Registro exitoso!',
            text: 'La resolución ha sido registrada correctamente.',
            confirmButtonColor: '#3085d6'
          });
        },
        error => {
          // Alerta de error
          Swal({
            type: 'error',
            title: 'Error',
            text: 'Hubo un problema al registrar la resolución. Intenta nuevamente.',
            confirmButtonColor: '#d33'
          });
        }
      );
    } else {
      // Alerta de formulario inválido
      Swal({
        type: 'warning',
        title: 'Formulario incompleto',
        text: 'Por favor, completa todos los campos requeridos antes de enviar.',
        confirmButtonColor: '#ffc107'
      });
    }
  }

  put(): void {
    if (this.resolutionForm.valid) {
      let data: IResolution = this.resolutionForm.getRawValue();
      this.dianService.putResolucion(data, this.id).subscribe(
        resp => {
          // Alerta de éxito
          Swal({
            type: 'success',
            title: '¡Actualización exitosa!',
            text: 'La resolución ha sido actualizada correctamente.',
            confirmButtonColor: '#3085d6'
          });
        },
        error => {
          // Alerta de error
          Swal({
            type: 'error',
            title: 'Error',
            text: 'Hubo un problema al actualizar la resolución. Intenta nuevamente.',
            confirmButtonColor: '#d33'
          });
        }
      );
    } else {
      // Alerta de formulario inválido
      Swal({
        type: 'warning',
        title: 'Formulario incompleto',
        text: 'Por favor, completa todos los campos requeridos antes de enviar.',
        confirmButtonColor: '#ffc107'
      });
    }
  }
}
